import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { GAPOrdersEntity } from "./entities/gap-orders.entity";
import { GAPController } from "./gap.controller";
import { GAPService } from "./gap.service";
import { GAPOrdersRepository } from "./repositories/gap-orders.repo";
import { GapOrderschildEntity } from "./entities/gap-orders-child.entity";
import { GapOrdersChildRepository } from "./repositories/gap-orders-child.repo";
import { GapPdfRepository } from "./repositories/gap-pdf.repo";
import { GapPdfInfoEntity } from "./entities/gap-pdf.entity";
import { AddressEntity } from "../Entites@Shahi/address/address-entity";
import { ColorEntity } from "../Entites@Shahi/color/color-entity";
import { SizeEntity } from "../Entites@Shahi/size/size-entity";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { AddressRepository } from "../Entites@Shahi/address/address.repo";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { ColorService } from "../Entites@Shahi/color/color-service";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { SizeService } from "../Entites@Shahi/size/size-service";
import { GapCOLineEntity } from "./entities/gap-co-line.entity";
import { GapCOLineRepository } from "./repositories/gap-co-line.repository";


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([
        GAPOrdersEntity,
        SizeEntity,
        ColorEntity,
        AddressEntity,
        GapOrderschildEntity,
        GapPdfInfoEntity,
        GapCOLineEntity
    ])],
  controllers: [GAPController],
  providers: [GAPService,ApplicationExceptionHandler,GAPOrdersRepository,SizeRepository,SizeService,ColorRepository,ColorService,AddressService,AddressRepository,GapOrdersChildRepository,GapPdfRepository,GapCOLineRepository]
})
export class GAPModule { }
